import React from "react";
import { ContentBlock } from "@/types/case-study";
import { Minus } from "lucide-react";

interface LineBreakBlockProps {
  block: ContentBlock;
  onUpdate: (content: any) => void;
  onRemove?: () => void;
  isActive?: boolean;
  isRemovable?: boolean;
}

export const LineBreakBlock: React.FC<LineBreakBlockProps> = ({
  block,
  onUpdate,
  onRemove,
  isActive = false,
  isRemovable = true,
}) => {
  return (
    <div className={`group relative ${isActive ? '' : ''}`}>
      <div className="flex items-center justify-center py-8">
        <div 
          className="h-px w-full"
          style={{
            background: 'linear-gradient(90deg, rgba(209, 213, 219, 0.00) 0%, #D1D5DB 50%, rgba(209, 213, 219, 0.00) 100%)'
          }}
        />
        {isActive && (
          <div className="absolute inset-0 flex items-center justify-center">          </div>
        )}
      </div>
      {isActive && isRemovable && onRemove && (
        <button
          onClick={onRemove}
          className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center text-xs opacity-70 hover:opacity-100 transition-opacity hover:bg-red-600"
          title="Delete this content block"
        >
          ×
        </button>
      )}
    </div>
  );
};

